import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const Link = ({ 
    children, 
    to, 
    href, 
    external = false, 
    target,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    // External link
    if (external || href) {
        return (
            <a 
                href={href || to} 
                target={target || '_blank'} 
                rel="noopener noreferrer"
                className={className} 
                style={style}
                {...props}
            >
                {children}
            </a>
        );
    }
    
    // Internal link using React Router
    return (
        <RouterLink 
            to={to} 
            className={className} 
            style={style}
            {...props}
        >
            {children}
        </RouterLink>
    );
};

export default Link;

